export const featureNames = {
  WORKFLOWS: "Workflows",
  PROCESS_FLOWS: "Process Flows",
  COLD_OUTREACH: "Cold Outreach",
  SEQUENCES: "Sequence",
};

export const sidebarFeatureNames = {
  WORKFLOWS: "Workflows",
  PROCESS_FLOWS: "Process Flows",
  COLD_OUTREACH: "Cold Outreach",
  SEQUENCES: "Sequences",
  INBOUND_AGENT: "Support",
  CODEBASE: "Codebase",
};

export const pluralFeatureNames = {
  SEQUENCES: "Sequences",
};
